import { RootState } from "../reducers";

export const getMapView = ({ mapView }: RootState) => mapView.present;

export const getMapViewHistoryState = ({ mapView }: RootState) => ({
  canUndo: mapView.past.length > 0,
  canRedo: mapView.future.length > 0,
});
